/**
 * Names exempt from the A1 regex, tagged `legacy` in PostHog (A7). The V2
 * client still emits the first six (typed in `src/events.ts`); the last three
 * come from payment-stack and are listed so the conformance tile ignores them.
 */
export const LEGACY_V2_CLIENT_EVENTS = [
  'account_created',
  'onboarding_step_viewed',
  'setup_handoff_clicked',
  'setup_landing_viewed',
  'setup_step_viewed',
  'setup_checkout_preview_shown',
] as const;

export const LEGACY_EXTERNAL_EVENTS = ['tpa_activated', 'first_transaction_succeeded', 'first_payout_succeeded'] as const;

export const LEGACY_EVENTS: readonly string[] = [...LEGACY_V2_CLIENT_EVENTS, ...LEGACY_EXTERNAL_EVENTS];
